// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__1tShh","notes":"Notes_notes__1ur1O","note":"Notes_note__3qvZN","markdown":"Notes_markdown__jYElK"};